<div class="container">
    <h1 class="page-title"
      [helpCenterButton]="permissionCode" [lang]="currentLang"
      [helpCenterDownloadButton]="permissionCode" [position]="'inline'" [lang]="currentLang">
    <span class="icon"><i class="fas fa-business-time"></i></span>{{ 'WarehouseCalendar.Header.Title' | translate }}</h1>
    <p-card>
      <div class="formgrid grid">
        <div class="col">
          <div class="btn-group">

            <button pRipple pButton (click)="subOneMonth($event)" label="{{ 'WarehouseCalendar.Header.PreviousMonth' | translate }}"></button>

            <button pRipple pButton (click)="goToToday($event)" class="ml-2" label="{{ 'WarehouseCalendar.Header.Today' | translate }}" ></button>

            <button pRipple pButton (click)="addOneMonth($event)" class="ml-2" label="{{ 'WarehouseCalendar.Header.NextMonth' | translate }}"></button>

            <button pRipple pButton *ngIf="isEditWarehouseCalendar"  (click)="CreateCalendar($event)" class="p-ml-2" label="{{ 'WarehouseCalendar.Header.CreateCalendar' | translate }}"></button>

            <button pRipple pButton *ngIf="isEditWarehouseCalendar" (click)="CopyCalendar($event)" class="p-ml-2" label="{{ 'WarehouseCalendar.Header.CopyCalendar' | translate }}"></button>
          </div>
        </div>

        <!-- <div class="col text-center">
          <label style="font-size:30px">{{ viewDate | calendarDate:(view + 'ViewTitle') }}</label>

        </div> -->

        <div class="col text-right">

          <p-dropdown (onChange)="dateOnChange($event)" [filter]="true" filterBy="label" [(ngModel)]="currentYear" [options]="yearList"></p-dropdown>
          <p-dropdown (onChange)="dateOnChange($event)" [filter]="true" filterBy="label" class="ml-2" [(ngModel)]="currentMonth" [options]="monthList"></p-dropdown>

        </div>

      </div>

      <div class="flex justify-content-end mb-4"></div>

      <div class="formgrid grid">
        <div class="col">
          <div [ngSwitch]="view">
            <mwl-calendar-month-view
              *ngSwitchCase="calendarView.Month"
              [viewDate]="viewDate"
              [events]="events"
              [refresh]="refresh"
              [activeDayIsOpen]="activeDayIsOpen"
              [cellTemplate]="customCellTemplate"
              [locale]="locale"
              (beforeViewRender)="beforeMonthViewRender($event)"
              (dayClicked)="dayClicked($event.day)"
              (eventClicked)="handleEvent('Clicked', $event.event)"
              (eventTimesChanged)="eventTimesChanged($event)"
            >
            </mwl-calendar-month-view>
          </div>

          <ng-template #customCellTemplate let-day="day" let-locale="locale">
            <div class="col" style="word-break: break-all">
              <div class="cal-cell-top">
                <!-- <span class="cal-day-badge" *ngIf="day.badgeTotal > 0">{{ day.badgeTotal }}</span> -->
                <span class="cal-day-number">{{ day.date | calendarDate:'monthViewDayNumber':locale }}</span>
              </div>

              <div style="margin-bottom: 5px" *ngFor="let event of day.events"class="role-block">

                <label class="font-bold">{{ event.descr }}</label>
                <br/>
                <small>{{ event.memo }}</small>

              </div>
            </div>
          </ng-template>

          <p-dialog header="{{ 'WarehouseCalendar.EditDialog.Title' | translate }}：{{clickDate}}" appendTo="body" [(visible)]="showEditModal" [modal]="true" [draggable]="false"
            [resizable]="false" [style]="{ width: '35%' }">
            <warehouse-calendar-edit *ngIf="showEditModal" [userProfile]="userProfile" [calendarEvents]="currentCalendarEvent" [clickDate]="clickDate" [systemCategory]="'WMS'"
              (warehouseCalendarImported)="warehouseCalendarImported($event)"></warehouse-calendar-edit>
          </p-dialog>
          <p-dialog header="{{ 'WarehouseCalendar.CreateCalendar.Title' | translate }}" appendTo="body"  [(visible)]="showCreateModal" [modal]="true" [draggable]="false"
          [resizable]="false" [style]="{ width: '35%' }">
          <warehouse-calendar-create *ngIf="showCreateModal" [systemCategory]="'WMS'"></warehouse-calendar-create>
          </p-dialog>
          <p-dialog header="{{ 'WarehouseCalendar.CopyCalendar.Title' | translate }}" appendTo="body" [(visible)]="showCopyModal" [modal]="true" [draggable]="false"
            [resizable]="false" [style]="{ width: '35%' }">
            <warehouse-calendar-copy *ngIf="showCopyModal" [systemCategory]="'WMS'"></warehouse-calendar-copy>
          </p-dialog>
        </div>
      </div>

  </p-card>
</div>
<help-dock
  [permissionCode]="permissionCode"
  [lang]="currentLang">
</help-dock>
